<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :money="componentParams.money">
        </component>
    </div>
</template>
<script>
import FinancialHome from './shopFinancial/Financial_home.vue'
import Settlement from './shopFinancial/Settlement.vue'
import Withdrawal from './shopFinancial/Withdrawal.vue'
import WithdrawalHistory from './shopFinancial/WithdrawalHistory.vue'

export default {
    name: 'FinancialManagement',
    components: {
        FinancialHome,
        Settlement,
        Withdrawal,
        WithdrawalHistory,
    },
    data() {
        return {
            currentComponent: 'FinancialHome',
            componentParams: {
                money: 0,
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'FinancialHome';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params };
            }
            this.currentComponent = componentName;
        }
    }
}
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>